import AOS from "aos";
import {Autoplay, EffectFade, Navigation, Swiper} from 'swiper';

document.addEventListener('DOMContentLoaded', () => {

  // mobile menu actions
  const active_elements = document.querySelectorAll('body, .hamburger, .navbar-main-menu');
  const hamburger = document.querySelector('.hamburger');

  if (window.innerWidth < 1100) {
    hamburger.addEventListener('click', () => {
      active_elements.forEach((element) => {
        element.classList.toggle('menu-active');
      });
    })
  }

  const modalButtons = document.querySelectorAll(".modal button");
  const modal = document.querySelector(".modal");

  if (modalButtons.length > 0) {
    document.body.classList.add("scroll-lock");

    modalButtons.forEach(btn => btn.addEventListener("click", () => {
      modal.remove();
      document.body.classList.remove("scroll-lock");

      const forms = document.querySelectorAll('.form');

      forms.forEach(form => form.reset());
    }));
  }

  //Scroll to section
  const links = document.querySelectorAll('.anchor-link');

  links.forEach(link => {
    const linkUrl = new URL(link.getAttribute('href'));
    link.addEventListener('click', (element) => {
        links.forEach(link => link.classList.remove('active'))
        link.classList.add('active');

        const currentRoute = link.getAttribute('href');
        const elementUrl = document.querySelector(linkUrl.hash);

        if (elementUrl) {
          element.preventDefault();
          const elementPosition = elementUrl.offsetTop;

          window.scrollTo({
            top:      elementPosition - 80,
            behavior: "smooth",
          })

          window.history.pushState(null, null, currentRoute);
        }

        if (window.innerWidth < 1100) {
          active_elements.forEach((element) => {
            element.classList.remove('menu-active');
          });
        }
      }
    )
  });

  AOS.init({
    duration: 800,
    once:     true,
  });

  const swiper = new Swiper(document.querySelector('.section-hero .swiper'), {
    modules:    [EffectFade, Navigation, Autoplay],
    loop:       true,
    fadeEffect: {
      crossFade: true,
    },
    effect:     'fade',
    autoplay:   {
      "delay": 3000,
    },
    speed:      1000,
  });

  if (window.innerWidth <= 867) {
    swiper.destroy();
  }

  new Swiper(document.querySelector('.section-about .swiper'), {
    modules:    [Navigation, Autoplay],
    loop:       true,
    autoplay:   {
      "delay": 3000,
    },
    speed:      1000,
    navigation: {
      nextEl: '.section-about .swiper-button-next',
      prevEl: '.section-about .swiper-button-prev',
    },
  })
});

// form foreach
window.onMessageSubmit = function(token) {
  document.querySelector('#contact-form input[name="g-recaptcha-token"]').value = token;
  document.querySelector('#contact-form').submit();
};



